<script lang="ts">
    import Cta from "../../components/CTA.svelte"
    import { newNotification } from "../../store"
    export let hashChanged: boolean
    export let modals: any
    export let ghostButton: boolean = true
</script>

<Cta
    type="{ghostButton ? 'ghostButton' : 'normal'}"
    icon="solar_album-outline"
    content="Einsatzbilder"
    noBorder="{!ghostButton}"
    on:click="{() => {
        if (hashChanged) {
            newNotification({
                html: 'Bitte speichern Sie Ihre Änderungen bevor Sie die Bilder bearbeiten',
                class: 'error',
            })
            return
        }
        modals.showTaskImages = true
    }}"
/>
<Cta
    type="{ghostButton ? 'ghostButton' : 'normal'}"
    icon="solar_folder-with-files-outline"
    content="Dateien"
    noBorder="{!ghostButton}"
    on:click="{() => {
        if (hashChanged) {
            newNotification({
                html: 'Bitte speichern Sie Ihre Änderungen bevor Sie die Dateien bearbeiten',
                class: 'error',
            })
            return
        }
        modals.showTaskFiles = true
    }}"
/>
<Cta
    type="{ghostButton ? 'ghostButton' : 'normal'}"
    icon="solar_alarm-add-outline"
    content="Zeitstempel"
    noBorder="{!ghostButton}"
    on:click="{() => {
        if (hashChanged) {
            newNotification({
                html: 'Bitte speichern Sie Ihre Änderungen bevor Sie die Zeitstempel bearbeiten',
                class: 'error',
            })
            return
        }

        modals.showManualProtocol = true
    }}"
/>

<style lang="less">
    @import "../../../../assets/variables.less";
</style>
